module.exports = __webpack_public_path__ + "static/assets/4c95673d9172b9fb615f3d34a337fb52.jpg";